import { CommonModule } from '@angular/common';
import { Component, computed, EventEmitter, inject, Input, Output, signal, Signal, WritableSignal } from '@angular/core';
import { DropdownOption } from 'src/ui/interfaces/dropdown.interfaces';
import { DropdownService } from 'src/utils/dropdown.service';

@Component({
  selector: 'app-dropdown-simple',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './dropdown-simple.component.html',
  styleUrl: './dropdown-simple.component.scss'
})
export class DropdownSimpleComponent {
  @Input() placeholder: string = 'Seleccione...';
  @Input() options: DropdownOption[] = [];
  @Input() dropdownId!: string;
  @Input() minWidth: string = '101px';
  
  @Input() backgroundColor: string = '';
  @Input() hasShadow: boolean = true;
  @Input() textColor: string = '';
  @Input() arrowColor: string = '';
  
  // Estilo para las opciones
  @Input() selectedBgColor: string = '';
  @Input() selectedTextColor: string = '';
  @Input() selectedBorderColor: string = '';
  @Input() hoverBgColor: string = '';
  @Input() optionTextColor: string = '';
  
  @Output() selectionChange = new EventEmitter<DropdownOption>();

  private readonly dropService = inject(DropdownService);

  isOpen: Signal<boolean> = computed(() => this.dropService.getOpenDropdown()() === this.dropdownId);
  selected: WritableSignal<DropdownOption | null> = signal(null);

  toggle() {
    this.dropService.toggleDropdown(this.dropdownId);
  }

  select(option: DropdownOption) {
    this.selected.set(option);
    this.selectionChange.emit(option);
    this.dropService.closeDropdown();
  }

  getButtonClasses(): any {
    const classes: any = {};
    
    if (this.backgroundColor) {
      classes[this.backgroundColor] = true;
    }
    
    if (this.textColor) {
      classes[this.textColor] = true;
    }
    
    return classes;
  }

  getOptionClasses(option: DropdownOption): any {
    const isSelected = this.selected()?.value === option.value;
    const classes: any = {};
    
    if (isSelected) {
      if (this.selectedBgColor) {
        classes[this.selectedBgColor] = true;
      }
      if (this.selectedTextColor) {
        classes[this.selectedTextColor] = true;
      }
      if (this.selectedBorderColor) {
        classes[this.selectedBorderColor] = true;
      }
    } else {
      if (this.hoverBgColor) {
        classes[this.hoverBgColor] = true;
      }
      if (this.optionTextColor) {
        classes[this.optionTextColor] = true;
      }
    }
    
    return classes;
  }
    reset() {
    this.selected.set(null);
  }
}
